(function () {
  'use strict';

  if (window.LSMasturbatorSizeChartLoaded) return;
  window.LSMasturbatorSizeChartLoaded = true;

  let lastSizeChartTrigger = null;

  function formatSizeChartNumber(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';

    return (Math.round(number * 100) / 100)
      .toFixed(2)
      .replace(/\.00$/, '')
      .replace(/(\.\d)0$/, '$1');
  }

  function parseSizeChartNumber(value) {
    if (value === null || value === undefined) return null;

    const cleaned = String(value)
      .replace(',', '.')
      .replace(/[^0-9.\-]/g, '')
      .trim();

    if (!cleaned) return null;

    const number = Number(cleaned);
    return Number.isFinite(number) ? number : null;
  }

  function getSizeChartCellCm(cell) {
    if (!cell) return null;

    const fromData = parseSizeChartNumber(cell.dataset.sizeCm);
    if (fromData !== null) return fromData;

    return parseSizeChartNumber(cell.textContent);
  }

  function setSizeChartCellCm(cell, value, calculated) {
    if (!cell || !Number.isFinite(value)) return;

    const cmValue = formatSizeChartNumber(value);
    const inchValue = formatSizeChartNumber(value / 2.54);

    cell.dataset.sizeCm = cmValue;
    cell.dataset.sizeCmLabel = cmValue;
    cell.dataset.sizeIn = inchValue;
    cell.dataset.sizeCalculated = calculated ? 'true' : 'false';
  }

  function getCell(table, rowKey, column) {
    return table.querySelector('[data-size-row="' + rowKey + '"][data-size-column="' + column + '"]');
  }

  function calculateMasturbatorSizeChartTables() {
    document.querySelectorAll('[data-masturbator-size-chart-table]').forEach(function (table) {
      table.querySelectorAll('[data-size-row="total_length"]').forEach(function (referenceCell) {
        const column = referenceCell.dataset.sizeColumn;

        const maxOuterDiameterCell = getCell(table, 'max_outer_diameter', column);
        const maxOuterCircumferenceCell = getCell(table, 'max_outer_circumference', column);
        const maxCoreDiameterCell = getCell(table, 'max_core_diameter', column);
        const maxCoreCircumferenceCell = getCell(table, 'max_core_circumference', column);
        const minCoreDiameterCell = getCell(table, 'min_core_diameter', column);
        const minCoreCircumferenceCell = getCell(table, 'min_core_circumference', column);
        const maxOuterDiameter = getSizeChartCellCm(maxOuterDiameterCell);
        if (maxOuterDiameter !== null) {
          setSizeChartCellCm(maxOuterCircumferenceCell, maxOuterDiameter * Math.PI, true);
        }

        const maxCoreDiameter = getSizeChartCellCm(maxCoreDiameterCell);
        if (maxCoreDiameter !== null) {
          setSizeChartCellCm(maxCoreCircumferenceCell, maxCoreDiameter * Math.PI, true);
        }

        const minCoreDiameter = getSizeChartCellCm(minCoreDiameterCell);
        if (minCoreDiameter !== null) {
          setSizeChartCellCm(minCoreCircumferenceCell, minCoreDiameter * Math.PI, true);
        }
      });
    });
  }

  function setSizeChartUnit(modal, unit) {
    if (!modal) return;

    modal.querySelectorAll('[data-size-chart-unit]').forEach(function (button) {
      const active = button.dataset.sizeChartUnit === unit;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    modal.querySelectorAll('[data-size-row][data-size-column]').forEach(function (cell) {
      const cmValue = getSizeChartCellCm(cell);

      if (cmValue === null) {
        cell.textContent = '—';
        return;
      }

      if (unit === 'in') {
        cell.textContent = cell.dataset.sizeIn || formatSizeChartNumber(cmValue / 2.54);
      } else {
        cell.textContent = cell.dataset.sizeCmLabel || formatSizeChartNumber(cmValue);
      }
    });
  }

  function unlockSizeChartScroll() {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function safeFocus(element) {
    if (!element || typeof element.focus !== 'function') return;

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function openSizeChartModal(modal, trigger) {
    if (!modal) return;

    lastSizeChartTrigger = trigger || null;
    calculateMasturbatorSizeChartTables();
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
    setSizeChartUnit(modal, 'cm');

    const focusTarget = modal.querySelector('[data-size-chart-close]') || modal.querySelector('.dildo-size-chart-lightbox-content');
    safeFocus(focusTarget);
  }

  function closeSizeChartModal(modal) {
    if (!modal) return;

    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    unlockSizeChartScroll();

    if (lastSizeChartTrigger) {
      safeFocus(lastSizeChartTrigger);
      lastSizeChartTrigger = null;
    }
  }

  calculateMasturbatorSizeChartTables();

  document.addEventListener('click', function (event) {
    const openBtn = event.target.closest('[data-size-chart-open]');
    if (openBtn) {
      event.preventDefault();
      const modal = document.getElementById(openBtn.dataset.sizeChartOpen);
      openSizeChartModal(modal, openBtn);
      return;
    }

    const closeBtn = event.target.closest('[data-size-chart-close]');
    if (closeBtn) {
      event.preventDefault();
      closeSizeChartModal(closeBtn.closest('.dildo-size-chart-lightbox'));
      return;
    }

    const unitBtn = event.target.closest('[data-size-chart-unit]');
    if (unitBtn) {
      event.preventDefault();
      const modal = unitBtn.closest('.dildo-size-chart-lightbox');
      setSizeChartUnit(modal, unitBtn.dataset.sizeChartUnit);
      return;
    }

    const sizeChartModal = event.target.closest('.dildo-size-chart-lightbox');
    if (sizeChartModal && event.target === sizeChartModal) {
      closeSizeChartModal(sizeChartModal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const openModal = document.querySelector('.dildo-size-chart-lightbox.open');
    if (openModal) closeSizeChartModal(openModal);
  });
})();
